import { ForumPlusOutlineIcon } from './ForumPlusOutlineIcon';

/**
 * author: nlsve
 * id 9AFD97C2-4B94-49EB-8D08-E2802D6FC377
 * name forum-plus-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/forum-plus-outline.svg
 * tags
 */
export const DiscussionPlusOutlineIcon = ForumPlusOutlineIcon;
export default DiscussionPlusOutlineIcon